import React from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';


export const Navibar = () => {

 
    return (

        
<nav className="navbar navbar-expand-md navbar-light bg-light sticky-top">
	<div className="container">
		<Link className="navbar-brand" to="/"><img src={'./img/techarabiya-logo.png'} /></Link>
		<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive">
			<span className="navbar-toggler-icon"></span>
		</button>
		<div className="collapse navbar-collapse" id="navbarResponsive">
			<ul className="navbar-nav ml-auto">
				<li className="nav-item">
					<Link to="/" className="nav-link">HOME</Link>
				</li>
				<li className="nav-item">
					<Link to="/About" className="nav-link">ABOUT US</Link>
				</li>
				<li className="nav-item dropdown">
					<Link className="nav-link dropdown-toggle" data-toggle="dropdown" role="button" to="/Services">
					SERVICES
					</Link>
					<div className="dropdown-menu" aria-labelledby="navbarDropdown">
						<Link className="dropdown-item" to="/DigitalInnovationLab">Digital Innovation Lab</Link>
						<Link className="dropdown-item" to="/SoftwareDevelopment">Software Development</Link>
						<Link className="dropdown-item" to="/MobileApp">Mobile App Development</Link>
						<Link className="dropdown-item" to="/Ecommerce">E-commerce Development & Web Designing
						</Link>
						<Link className="dropdown-item" to="/Iot">Custom IoT Software Development
						</Link>
						<Link className="dropdown-item" to="/Blockchain">Blockchain Development
						</Link>

					</div>
				</li>

				<li className="nav-item">
					<Link to="/Industries" className="nav-link">INDUSTRIES</Link>
				</li>
				<li className="nav-item">
					<Link to="/TechnologyStack" className="nav-link">TECHNOLOGY STACK</Link>
				</li>
				<li className="nav-item">
					<Link to="/ContactUs" className="nav-link">CONTACT US</Link>
				</li>
			</ul>

		</div>

	</div>

</nav>
      
        
    )
}

export default Navibar